const campusTour = {
  title: 'Campus information desk',
  voiceLang: 'en-GB',
  script:
    'Good morning and welcome to Greenfield College. The library opens at eight thirty and closes at nine in the evening on weekdays. If you need a student card, go to the reception desk on the ground floor of the administration building, not the student union. Next Tuesday there is a short orientation talk in Lecture Theatre B at four o’clock. Please bring one form of photo identification.',
  questions: [
    {
      text: 'Where should new students collect a student card?',
      options: [
        'The student union',
        'Reception in the administration building',
        'Lecture Theatre B',
      ],
      answer: 'Reception in the administration building',
    },
    {
      text: 'When is the orientation talk?',
      options: ['Monday at 8:30', 'Tuesday at 4:00', 'Weekdays at 9:00'],
      answer: 'Tuesday at 4:00',
    },
  ],
};

export const LISTENING_PASSAGES = {
  'accent-training': {
    title: 'Housing enquiry — British speaker',
    voiceLang: 'en-GB',
    script:
      'Hello, I’m calling about the room to let near the station. It’s one hundred and forty pounds a week, including water but not electricity. Viewings are on Thursday afternoon. Could you bring your passport and a reference from your last landlord?',
    questions: [
      {
        text: 'What is included in the rent?',
        options: ['Electricity', 'Water', 'Internet'],
        answer: 'Water',
      },
      {
        text: 'What must the caller bring to the viewing?',
        options: ['A bank statement', 'Passport and a landlord reference', 'A student card only'],
        answer: 'Passport and a landlord reference',
      },
    ],
  },
  'academic-lectures': {
    title: 'Lecture extract — urban heat',
    voiceLang: 'en-US',
    script:
      'Today we will look at the urban heat island effect. Cities absorb more sunlight than countryside because of dark roofs and asphalt. The result is night-time temperatures several degrees higher than nearby rural areas. Researchers measure this with weather stations placed on rooftops and in parks.',
    questions: [
      {
        text: 'Why are cities warmer at night?',
        options: [
          'They have more parks',
          'Dark roofs and asphalt absorb sunlight',
          'Weather stations produce heat',
        ],
        answer: 'Dark roofs and asphalt absorb sunlight',
      },
    ],
  },
  'distractor-recognition': {
    title: 'Changed booking',
    voiceLang: 'en-GB',
    script:
      'You originally booked a table for six on Friday at seven. I’m afraid that time is now full. We can do Friday at eight thirty, or Saturday at seven. The name on the booking is still Patel, and we will keep the high chair you requested.',
    questions: [
      {
        text: 'Which Friday time is still available?',
        options: ['7:00', '8:30', '6:00'],
        answer: '8:30',
      },
    ],
  },
  'everyday-conversations': {
    title: 'Pharmacy conversation',
    voiceLang: 'en-AU',
    script:
      'I need something for a sore throat before my flight tomorrow. The pharmacist says the lozenges by the till are fine, but avoid the ones with codeine if you are driving. Take two every four hours, and drink warm water rather than cold juice.',
    questions: [
      {
        text: 'What should the customer avoid if driving?',
        options: ['Warm water', 'Lozenges with codeine', 'The flight'],
        answer: 'Lozenges with codeine',
      },
    ],
  },
  'following-directions': {
    title: 'Walking directions',
    voiceLang: 'en-GB',
    script:
      'Leave the station and turn left. Walk past the supermarket, then take the second right onto Harbour Street. The museum is opposite the blue bus stop, not next to the café. If you reach the river, you have gone too far.',
    questions: [
      {
        text: 'Where is the museum?',
        options: [
          'Next to the café',
          'Opposite the blue bus stop',
          'Beside the supermarket',
        ],
        answer: 'Opposite the blue bus stop',
      },
    ],
  },
  'listening-for-details': {
    title: 'Conference details',
    voiceLang: 'en-US',
    script:
      'The workshop starts at nine fifteen, not nine. Please collect your badge from desk three. Lunch is in the west hall, and the afternoon session is in room 4B. Remember to bring a laptop; paper handouts will not be provided.',
    questions: [
      {
        text: 'Where should people collect a badge?',
        options: ['The west hall', 'Desk three', 'Room 4B'],
        answer: 'Desk three',
      },
    ],
  },
  'listening-strategies': {
    title: 'Library reminder',
    voiceLang: 'en-GB',
    script:
      'Before you listen for every word, decide what you need: a date, a name, or a reason. In this announcement, the key fact is that overdue books can now be renewed online until Friday, but reserved items must still be returned to the desk.',
    questions: [
      {
        text: 'What must still be returned to the desk?',
        options: ['All overdue books', 'Reserved items', 'Online renewals'],
        answer: 'Reserved items',
      },
    ],
  },
  'multiple-speakers': {
    title: 'Group project meeting',
    voiceLang: 'en-US',
    script:
      'Maya will write the introduction. Tom wanted the charts, but he is away on Thursday, so Priya will do the data instead. They agree to meet in the computer lab at five, not the café, because they need the printer.',
    questions: [
      {
        text: 'Who will handle the data?',
        options: ['Maya', 'Tom', 'Priya'],
        answer: 'Priya',
      },
    ],
  },
  'note-taking': {
    title: 'Lecture notes cue',
    voiceLang: 'en-GB',
    script:
      'Write abbreviations, not full sentences. The three causes of soil erosion mentioned are wind, heavy rain, and overgrazing. The lecturer says the exam will ask for two examples, not all three, so mark the two you remember best.',
    questions: [
      {
        text: 'How many erosion examples will the exam ask for?',
        options: ['One', 'Two', 'Three'],
        answer: 'Two',
      },
    ],
  },
  'paraphrase-detection': {
    title: 'Paraphrase in a talk',
    voiceLang: 'en-AU',
    script:
      'The speaker says the town “cut the number of private cars entering the centre”. In the question this may appear as “reduced traffic in the downtown area”. Both mean the same thing. The policy started in March, not May.',
    questions: [
      {
        text: 'When did the policy start?',
        options: ['March', 'May', 'The talk does not say'],
        answer: 'March',
      },
    ],
  },
  'prediction-skills': {
    title: 'Form completion talk',
    voiceLang: 'en-GB',
    script:
      'If the form has a blank after “Membership number”, expect digits. The speaker gives the number as four two one, then eight zero six. The joining fee is twenty-five pounds, paid at reception, not online.',
    questions: [
      {
        text: 'What is the joining fee?',
        options: ['£25', '£42', '£80'],
        answer: '£25',
      },
    ],
  },
  'understanding-numbers': {
    title: 'Numbers and dates',
    voiceLang: 'en-US',
    script:
      'The flight number is BA 1567, departing on the thirteenth of June at sixteen forty. There are two pieces of luggage allowed, each up to twenty-three kilos. The gate number will appear on screen thirty minutes before boarding.',
    questions: [
      {
        text: 'What is the departure time?',
        options: ['1:67', '16:40', '13:06'],
        answer: '16:40',
      },
    ],
  },
};

export const REVISION_LISTENING_PASSAGE = campusTour;

export function getListeningPassageForCourse(courseId) {
  return LISTENING_PASSAGES[courseId] || null;
}
